// extracted by mini-css-extract-plugin
module.exports = {"containerText":"BoxlegalSupport_containerText__15nz_","clWidth520":"BoxlegalSupport_clWidth520__2GzUV","clWidth370":"BoxlegalSupport_clWidth370__3LzId"};